import { css } from '@emotion/react';
import { spinDirection, iconRotate } from './helpers';
import { fonts, animate } from '../../styles/theme';

export const withText = css`
  font-size: ${fonts.sans.size.normal};
  margin-right: 5px;
`;

export const withTextLeft = css`
  font-size: ${fonts.sans.size.normal};
  margin-left: 5px;
`;

export const fixedWidth = css`
  &:before {
    width: 16px;
  }
`;

export const spin = (props) => css`
  &:before {
    animation: ${spinDirection(props.spin)} ${animate.spin} infinite steps(8);
  }
`;

export const flip = (props) => css`
  &:before {
    transform: ${iconRotate(props.flip)};
    margin: 0;
  }
`;
